<div *ngIf="isLoading" class="spinner">
  <p-progressSpinner></p-progressSpinner>
</div>

